// extracted by mini-css-extract-plugin
export var body = "_g7-5";
export var closeButton = "_g7-f";
export var container = "_g7-1";
export var content = "_g7-2";
export var cta = "_g7-c";
export var ctaLabel = "_g7-b";
export var eyebrow = "_g7-3";
export var howTo = "_g7-6";
export var image = "_g7-e";
export var modal = "_g7-0";
export var socialButton = "_g7-d";
export var stepCard = "_g7-8";
export var stepLabel = "_g7-a";
export var stepNumber = "_g7-9";
export var steps = "_g7-7";
export var title = "_g7-4";